import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { FeaturedProducts } from '../components/FeaturedProducts';
import { BenefitsSection } from '../components/BenefitsSection';
import { AboutSection } from '../components/AboutSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen w-full bg-white" data-id="element-153">
      <Header data-id="element-154" />
      <main data-id="element-155">
        <HeroSection data-id="element-156" />
        <FeaturedProducts data-id="element-157" />
        <BenefitsSection data-id="element-158" />
        <AboutSection data-id="element-159" />
        <CTASection data-id="element-160" />
      </main>
      <Footer data-id="element-161" />
    </div>;
}